import React from "react";

const CoreContext = React.createContext()

export const CoreProvider = CoreContext.Provider
export const CoreConsumer = CoreContext.Consumer

export default CoreContext